export enum BreakdownTypeEnum {
  process = "process",
  processGroup = "processGroup",
  shift = "shift",
}

export type BreakdownType = keyof typeof BreakdownTypeEnum;
